import { publicationProxy } from '../common/apiProxy';
import actionTypes from './publication.actionTypes';
import { getPaginationInfo, getPublicationFiltersQueryString, 
         getPublicationSearchText, getPublicationListSortConfig,
         getMetricsList, getAggregateMetricNames } from './publication.selectors';
import { extractTokenForSearch, normalizeSortConfig } from '../common/sponsorships/list/sponsorshipHelper';
import { getQueryStringWithPublicationStatus } from '../common/sponsorships/filters/filterHelper';
import filterId from '../common/sponsorships/filters/filter_ids';

//getPublications

let timeoutId = null;

function receivePublications(responseContent, filterQueryString = null, searchText = null, 
                                sortField = null, sortDirection = null, metrics=null, aggregateMetrics = null) {
    const action = {
        type: actionTypes.RECEIVE_PUBLICATIONS_SUCCESS,
        ...responseContent,
        filterQueryString,
        searchText,
        sortField,
        sortDirection,
        metrics,
        aggregateMetrics,
        receivedAt: Date.now()
    };
    return action;
}

async function requestPublications(dispatch, options, shouldDelay = false, token = null, tenantId = null) {


    if(shouldDelay) {
        clearTimeout(timeoutId);
    }

    const waitMilliseconds = shouldDelay ? 2000: 0;
    timeoutId = setTimeout(() => {
        dispatch({type: actionTypes.REQUEST_PUBLICATIONS, ...options});
        publicationProxy.getPublications(options, token, tenantId).then(responseContent => {
            let action = receivePublications(responseContent, 
                options.filterQueryString, options.searchText,
                options.sortField, options.sortDirection, 
                options.metrics, options.aggregateMetrics);
            dispatch(action);
        });
    }, waitMilliseconds);
}

export function getPublications({ pageSize, pageNumber, metrics, aggregateMetrics, sortByField, sortByDirection, filterQueryString }, token, tenantId) {
    return async (dispatch) => {

        let sortConfig = {};
        if(sortByField && sortByDirection) {
            sortConfig = normalizeSortConfig({field: sortByField, dir: sortByDirection});
        }

        await requestPublications(dispatch, {
            pageSize,
            pageNumber,
            metrics,
            aggregateMetrics,
            filterQueryString,
            ...sortConfig
        }, false, token, tenantId);
    };
}

export function exportPublications(exportFields, token, tenantId) {
    return async(dispatch, getState) => {

        //dispatch({type: actionTypes.EXPORT_PUBLICATIONS });

        const state = getState();
        const options = {
            exportFields,
            filterQueryString: completeFilterQueryString(state),
            searchTexT: getPublicationSearchText(state),
            ...getPublicationListSortConfig(state),
            metrics: getMetricsList(state)
        };
        publicationProxy.exportPublications(options, token, tenantId);
        //dispatch({type: actionTypes.EXPORT_PUBLICATIONS_SUCCESS });

    };
}

export function changePublicationListPage({skip, take}, token, tenantId) {
    return async(dispatch, getState) => {
        const pageSize = take;
        const pageNumber = (skip / pageSize) + 1;

        const state = getState();
        const filterQueryString = completeFilterQueryString(state);
        const searchText = getPublicationSearchText(state);
        const sortConfig = getPublicationListSortConfig(state);
        const metrics = getMetricsList(state);
        const aggregateMetrics = getAggregateMetricNames(state);

        await requestPublications(dispatch, { 
            pageSize, 
            pageNumber, 
            filterQueryString, 
            searchText,
            metrics,
            aggregateMetrics,
            ...sortConfig
        }, false, token, tenantId);
    };
}

export function changePublicationListFilter(filterQueryString, token, tenantId) {
    return async(dispatch, getState) => {
        const state = getState();
        const { pageSize } = getPaginationInfo(state);
        //We need to reset the page because it is a different query.
        const pageNumber = 1; 
        const searchText = getPublicationSearchText(state);
        const sortConfig = getPublicationListSortConfig(state);
        const metrics = getMetricsList(state);
        const aggregateMetrics = getAggregateMetricNames(state);
        const newQueryString = completeFilterQueryString(state, filterQueryString);

        await requestPublications(dispatch, { 
            pageSize, 
            pageNumber, 
            filterQueryString: newQueryString, 
            searchText,
            metrics,
            aggregateMetrics,
            ...sortConfig
        }, true, token, tenantId);

    };
}

export function changePublicationListOrder({field, dir}, token, tenantId) {
    return async(dispatch, getState) => {
        const state = getState();
        const { pageSize } = getPaginationInfo(state);
        const pageNumber = 1;
        const filterQueryString = completeFilterQueryString(state);
        const searchText = getPublicationSearchText(state);
        const metrics = getMetricsList(state);
        const aggregateMetrics = getAggregateMetricNames(state);

        const sortConfig = normalizeSortConfig({field, dir});

        await requestPublications(dispatch, {
            pageSize, 
            pageNumber, 
            filterQueryString, 
            searchText,
            metrics,
            aggregateMetrics,
            ...sortConfig
        }, false, token, tenantId);
    };
}

export function searchPublications(searchText, token, tenantId) {
    return async(dispatch, getState) => {
        const state = getState();
        const { pageSize } = getPaginationInfo(state);
        const pageNumber = 1;
        const filterQueryString = completeFilterQueryString(state);
        const sortConfig = getPublicationListSortConfig(state);
        const metrics = getMetricsList(state);
        const aggregateMetrics = getAggregateMetricNames(state);

        const searchToken = extractTokenForSearch(searchText);

        await requestPublications(dispatch, {
            pageSize, 
            pageNumber, 
            filterQueryString, 
            searchText: searchToken,
            metrics,
            aggregateMetrics,
            ...sortConfig
        }, false, token, tenantId);
    };
}

//getPublicationFilters

function receivePublicationFilters(responseContent) {
    const action = {
        type: actionTypes.RECEIVE_PUBLICATION_FILTERS_SUCCESS,
        ...responseContent.data,
        receivedAt: Date.now()
    };
    return action;
}

export function getPublicationFilters(status_ids, token, tenantId){
    return async (dispatch) => {
        dispatch({type: actionTypes.REQUEST_PUBLICATION_FILTERS});
        const responseContent = await publicationProxy.getPublicationFilters(status_ids, token, tenantId);
        let action = receivePublicationFilters(responseContent);
        dispatch(action);
    };
}

function completeFilterQueryString(state, existingQueryString = null) {
    let result = existingQueryString === null ? getPublicationFiltersQueryString(state): existingQueryString;

    if(!result) {
        result = getQueryStringWithPublicationStatus();
    } else if(!result.includes(filterId.STATUS)) {
        result += '&' + getQueryStringWithPublicationStatus();
    }

    return result;
}